module.exports = __webpack_public_path__ + "assets/images/cosmote_5.7c85826f737fa9ecbbce8dd45d7d969d.png";